import { IsEmail, IsOptional, IsString, IsUUID } from 'class-validator';

export class UserCreateDto {
  @IsEmail()
  email!: string;

  @IsUUID()
  @IsOptional()
  externalId?: string;

  @IsString()
  @IsOptional()
  birthdate?: string;

  @IsString()
  @IsOptional()
  firstName?: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsString()
  @IsOptional()
  patientId?: string;
}
